<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data'
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
      <e-columns :columns='shipColumns' textAlign='Center' clipMode='EllipsisWithTooltip'>
        <e-column type="checkbox" width="20" textAlign="center"></e-column>
        <e-column field='id' minWidth='10' :headerText='$t("DeployManagement.nodeID")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>  
        <e-column field='name' minWidth='10' :headerText='$t("DeployManagement.nodeName")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='ip' minWidth='10' :isPrimaryKey='true' :headerText='$t("DeployManagement.nodeIP")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='displaySoftwareVersion' minWidth='10' :headerText='$t("DeployManagement.displaySoftWareVersion")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='initStatus' minWidth='10' :headerText='$t("DeployManagement.initStatus")' textAlign='Center' width="120" clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getTrackListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager> 
  </div>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import bus from '../bus.js';
  import { EventBus } from '../../../plugins/eventBus';

  const { mapGetters, mapActions } = createNamespacedHelpers('trackConfig');
  export default {
    name: 'configExTable',
    components: {
    },
    props: ['trackType'],
    data() {
      return {
        hasSelectedAll: false,
        deselectedIdArray:[],
        lastPageCount: 0,
        hasRefreshed: false,
        selectionOptions: { type: 'Single' },
        contextMenuItems: [
          { text: `${this.$t('Track.activationTask')}` },
          { text: `${this.$t('Track.suspendTask')}` },
          { text: `${this.$t('Track.taskDeletion')}` },
          { text: `${this.$t('Track.taskTracking')}` },
          { text: `${this.$t('Track.taskDetails')}` }
        ],
        trackStatus: { // 配置不同状态对应的值
          issued: 0,
          greate: 1,
          tracing: 2,
          hangup: 3,
          delete: 4,
          finish: 5
        },
        queryConditions: {
          keywords: '' 
        },
        currentNeInfo: '',
        data: [],
        primaryDatas: [],
        page: {
          pageNo: 1,
          pageSize: 20,
          totalCount: 0,
          pageCount: 20,
          limit: 0
        },
        currentSelectDataId: '',
        addDialogSetting: {
          styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'add',
            title: this.$t('Track.createTask'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
              { click: this.saveAddTask, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
              //去掉保存功能
              // { click: this.saveTask, buttonModel: { content: this.$t('Track.save'), isPrimary: true } }
            ]
          }
        },
        updateDialogSetting: {
          styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'update',
            title: this.$t('Track.updateTask'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
              { click: this.saveUpdateTask, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
              //去掉保存功能
              // { click: this.saveTask, buttonModel: { content: this.$t('Track.save'), isPrimary: true } }
            ]
          }
        },
        detailDialogSetting: {
          styles: {
            width: '810px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'detail',
            title: this.$t('Track.signalingDetails'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.close'), isPrimary: true } }
            ]
          }
        },
        shipColumns: [
          {
            field: 'ShippedDate',
            headerText: 'Shipped Date',
            format: 'yMd',
            textAlign: 'Right',
            width: 150,
            minWidth: 10
          },
          {
            field: 'ShipCountry',
            headerText: 'Ship Country',
            width: 150,
            minWidth: 10
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['currentNe']),
      ...mapGetters(['neVisionList']),
      ...mapGetters(['resourceIdList'])
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    methods: {
      ...mapActions(['setCurrentNe']),
      actionComplete(args) {
        console.log("actionComplete:",args)
        this.hasRefreshed = false;
      },
      actionBegin(args) {
        console.log("actionBegin lastPageCount:",this.lastPageCount)
        if(!(this.lastPageCount === 0)){
          this.hasRefreshed = true;
        }else{
          this.hasRefreshed = false;
        }
      },
      rowDeselected(args) {
        const headerCheckbox = document.querySelector('.e-checkselectall');
        headerCheckbox.checked = true;
        console.log("rowDeselected isInteracted:,this.hasSelectedAll:",args.isInteracted,this.hasSelectedAll)
        if(args.isInteracted&&this.hasSelectedAll){
          args.data.forEach((item)=>{
            if(!this.deselectedIdArray.includes(item.id)){
              this.deselectedIdArray.push(item.id);
            }
          });
        }
        console.log("rowDeselected hasRefreshed:",this.hasRefreshed)
        if(!args.isInteracted&&!this.hasRefreshed){
          this.hasSelectedAll = false;
          this.lastPageCount = args.data.length;
        }
        console.log("hasSelectedAll:",this.hasSelectedAll)
        console.log("deselectedIdArray:",this.deselectedIdArray)
      },
      onDataBound(args) {
        if(this.hasSelectedAll){
          const gridObject = this.$refs.grid.ej2Instances;
          gridObject.selectRowsByRange(0,gridObject.getRows().length - 1);
          const rows = gridObject.getSelectedRecords();
          console.log("onDataBound rows:",rows)
          console.log("onDataBound deselectedIdArray:",this.deselectedIdArray)
          const selectArray = [];
          for(var i=0;i<rows.length;i++){
            if(!this.deselectedIdArray.includes(rows[i].id)){
              selectArray.push(i);
            }
          }
          gridObject.selectRows(selectArray);
        }
      },
      selectAll(){
        const gridObject = this.$refs.grid.ej2Instances;
        if(this.hasSelectedAll){
          this.hasSelectedAll = false;
          gridObject.clearSelection();
        }else{
          this.hasSelectedAll = true;
          gridObject.selectRowsByRange(0,gridObject.getRows().length - 1);
        }
      },
      rowSelected(args){
        console.log("rowSelected",args)
        console.log("limit:",this.page.limit)
        console.log("hasRefreshed:",this.hasRefreshed)
        if(typeof args.rowIndexes !== 'undefined'&&!this.hasRefreshed){
          this.hasSelectedAll = true;
          this.deselectedIdArray = [];
          this.lastPageCount = args.data.length;
        }else{
          const index = this.deselectedIdArray.indexOf(args.data.id);
          if(index>-1){
            this.deselectedIdArray.splice(index,1);
          }
        }
        console.log("hasSelectedAll:",this.hasSelectedAll)
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        console.log("=======>",selectedRecords)
      },
      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
          menuArgs.cancel = true;
          return;
        }
        const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
        childList.forEach(elem => {
          elem.style.display = 'block';
        });
        switch (this.getCheckedVals().taskStatus) {
          case this.trackStatus.greate: break;
          case this.trackStatus.tracing: // 正在执行时不显示激活选项
            childList[0].style.display = 'none';
            break;
          case this.trackStatus.hangup: // 挂起时不显示挂起选项
            childList[1].style.display = 'none';
            break;
          case this.trackStatus.delete: break;
          case this.trackStatus.finish: break;
          default:
        }
      },
      dialogHide() {
        this.$refs.addDialog.clear();
        this.$refs.addDialog.close();
        this.$refs.updateDialog.clear();
        this.$refs.updateDialog.close();
        this.$refs.detailDialog.clear();
        this.$refs.detailDialog.close();
      },
      getCheckedData(exportAll,standardStationId) {
        const This = this;
        // false: 不支持多选   true: 支持多选
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        selectedRecords.forEach((item)=>{
          if(item.initStatus==="finished"){
            item.initStatus="1";
          }else{
            item.initStatus="0";
          }
        });
        let params={
          hasSelectedAll: exportAll,
          data: selectedRecords,
          nodeIdRange: This.queryConditions.keywords,
          totalCount: This.page.totalCount,
          standardStationId: standardStationId
        }
        return params;
      },
      getCheckedVals() {
        const checkedData = this.getCheckedData(true);
        if (checkedData) {
          return checkedData[0];
        }
        return false;
      },
      getTrackListData() {
        const This = this;
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        console.log("getTrackListData==========",This.queryConditions.keywords)
        const params = {
          nodeIdRange: This.queryConditions.keywords ? This.queryConditions.keywords : '',
          pageNo: parseInt(This.page.pageNo, 10),
          pageSize: parseInt(This.page.pageSize, 10)
        };
        // 获取表格数据
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
          This.$axios.post('/lte/ems/config/mml/queryAllNePageByNodeIdSection',params).then((response) => {
            if (response && response.status === 200) {
              let pageObj = response.data.resultVal;
              pageObj.result.forEach((item)=>{
                if(item.initStatus==='1'){
                  item.initStatus="finished";
                }else{
                  item.initStatus="unfinished";
                }
              });
              const result = pageObj;
              This.page.totalCount = result.totalCount;
              console.log("pageObj:",pageObj)
              This.page.limit = pageObj.result.length;
              This.data = result.result;
              // This.primaryDatas = This.data;
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
      }
    },
    mounted() {
       this.getTrackListData();
      // bus.$on('loadTrackTable', (neNode) => {
      //   this.currentNeInfo = neNode;
      //   this.queryConditions.keywords = '';
      //   this.page.pageNo = "1";
      //   this.$refs.pager.ej2Instances.currentPage = 1;
      //   this.getTrackListData();
      //   this.setCurrentNe(neNode);
      //   bus.$emit('curMoData');
      // });
      bus.$on('refreshTrackTable', () => {
        this.getTrackListData();
      });
      // this.getTrackListData();
      setTimeout(this.websocketCallback, 5000);
    },
    beforeDestroy() {
      // bus.$off('loadTrackTable');
      bus.$off('refreshTrackTable');
    }
  };
</script>
